<template>
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
  >
    <path d="M6.77136 6.69902L7.10193 4.54369H5.03397V3.14501C5.03397 2.55534 5.32283 1.98059 6.24908 1.98059H7.18933V0.145641C7.18933 0.145641 6.33601 0 5.52025 0C3.81704 0 2.70388 1.03223 2.70388 2.90098V4.54369H0.810669V6.69902H2.70388V11.9094C3.0835 11.969 3.47258 12 3.86893 12C4.26529 12 4.65437 11.969 5.03397 11.9094V6.69902H6.77136Z" fill="#0F0017"/>
  </svg>
</template>
